import { gqlClient } from '@/api/graphql-client';
import applianceKeys from '@/api/queries/appliances/keyFactory';
import productSpecKeys from '@/api/queries/productSpecs/keyFactory';
import { graphql } from '@/gql';
import {
  CreateApplianceInput,
  CreateApplianceMutation as CreateApplianceMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const CreateApplianceMutation = graphql(`
  mutation CreateAppliance($input: CreateApplianceInput!) {
    createAppliance(input: $input) {
      id
    }
  }
`);

const useCreateAppliance = (
  options?: UseMutationOptions<
    CreateApplianceMutationResult,
    Error,
    CreateApplianceInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) =>
      gqlClient.request(CreateApplianceMutation, { input }),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: applianceKeys.all });
      // The spec search exposes each spec's Appliance, so refresh it too.
      void queryClient.invalidateQueries({ queryKey: productSpecKeys.all });
    },
    ...options,
  });
};

export default useCreateAppliance;
